module.exports = __webpack_public_path__ + "img/keder_rot_candy.925ff57c.jpg";